import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { heroMockup } from '../data/landing';
const guarantees = ['Descarga digital', 'Pago único', 'Acceso inmediato'];
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="relative overflow-hidden bg-stone-50" data-id="element-101" data-mp="4lqkazhutj53">
      <div className="mx-auto flex max-w-5xl flex-col items-center px-5 pb-16 pt-6 text-center sm:pt-10 lg:pb-20" data-id="element-102" data-mp="4n9wof0e3a1l">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="font-serif text-[1.95rem] font-black leading-[1.06] tracking-[-0.01em] text-stone-900 min-[420px]:text-4xl sm:text-5xl sm:leading-[1.04] lg:text-[4rem]" data-id="element-103" data-mp="127ed7af3pjbv">
          Entendé Contabilidad desde sus Bases con{' '}
          <span className="italic text-brand" data-id="element-104" data-mp="3cz5v8bjvq00c">300 Mapas Mentales</span> y Material para Practicar
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease
      }} className="mt-10 w-full" data-id="element-105" data-mp="3j8se7xjcfdo9">
          <img src={heroMockup} alt="MegaPack Contabilidad Lista: los 10 tomos, la vista en computadora y teléfonos, y los 5 bonos de práctica" className="mx-auto w-full max-w-4xl" width={1536} height={1024} data-id="element-106" data-mp="399jnrenosh6n" />
        </motion.div>

        <div className="mt-9 flex w-full justify-center" data-id="element-107" data-mp="30fybc1yzvc0e">
          <CtaButton data-id="element-108" data-mp="359sy5e9wc73p">Quiero mi MegaPack Contabilidad Lista</CtaButton>
        </div>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold uppercase tracking-[0.14em] text-stone-600" data-id="element-109" data-mp="2qkmsb7gjzimu">
          {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-110" data-mp="2hinaicxpsaiu" data-mpi={index}>
              {index > 0 ? <span aria-hidden="true" className="text-stone-300" data-id="element-111" data-mp="2lkqz839e9bm2">•</span> : null}
              <span data-id="element-112" data-mp="2lmuzmb833shl">{item}</span>
            </li>)}
        </ul>
      </div>
    </header>;
}